module.exports = {"loading":"Loading data","text":"This may take a few seconds, please wait..."}